import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../pages/About.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../pages/Products.vue')
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: () => import('../pages/Solutions.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../pages/News.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../pages/Contact.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../pages/login/Login.vue'),
    meta: { hideHeaderFooter: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../pages/login/Register.vue'),
    meta: { hideHeaderFooter: true }
  },
  {
    path: '/users/profile',
    name: 'UserProfile',
    component: () => import('../pages/users/UserProfile.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
